import { render, staticRenderFns } from "./UploadPatientLienDocumentModal.vue?vue&type=template&id=3a8c29a5"
import script from "./UploadPatientLienDocumentModal.vue?vue&type=script&lang=ts"
export * from "./UploadPatientLienDocumentModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports